import { EnvironmentNames } from '../../lib/_core/constants/environments';
import { WIRING_INSTRUCTIONS_FONTE } from '../../lib/_core/constants/wiring-instructions';
import { environment as swissEnv } from '../swiss/environment.swiss-test';

export const environment = {
  fund: {
    primaryColor: 'rgb(22,71,115)',
    secondaryColor: 'rgb(11,43,64)',
    ternaryColor: 'rgb(30,89,89)',
    logo: 'assets/logos/fonte_logo.png',
    publicLogo: 'assets/logos/fonte_logo.png',
    lightDonateNowButtonLink: 'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/fonte/fonte_light.png',
    darkDonateNowButtonLink: 'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/fonte/fonte_dark.png',
    lightDonateNowButtonSrc: 'assets/donate-buttons/fonte_light.png',
    darkDonateNowButtonSrc: 'assets/donate-buttons/fonte_dark.png',
    favicon: 'assets/favicon/favicon_fonte.png',
    wiringInstructions: WIRING_INSTRUCTIONS_FONTE,
    eftInstructions: null,
    stripeKey:
      'pk_test_51P1tOSHuJC3wXMRsFdFS2eIyKU507fFBXNEbbT8Z09DOyYvaBp0VYRySO9xeMB0h5SZHnTFBROISfUmRPtrHmyfT00gnMxMgcy',
    homeLink: 'https://fontendowment.com/en/index.php',
    contact: 'https://fontendowment.com/en/index.php#contact',
    blog: 'https://www.instagram.com/fontendowment/',
    privacyPolicy: 'https://fontendowment.com/politicadeprivacidade.php',
    terms: '',
    mailTo: 'relacionamento@fontendowment.com',
    name: 'Fonte Endowment',
    tenantId: 'fonte_dev',
    server: 'https://portal.fontendowment.com/api',
    url: 'https://portal.fontendowment.com',
    gsUrl: 'https://dev.givingspace.com',
    environmentName: EnvironmentNames.FONTE,
    languages: ['en-fonte'],
    production: true,
    multiCurrency: false,
    redirectSourceUrl: swissEnv.fund.url,
    signatureApiKey: '',
  },
};
